import React, { memo, useContext, useEffect } from 'react';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { disableTestEnv } from 'services/api/testEnv';
import { sideDrawerStatus } from '../FBODrawer';
import { Icon } from 'ui/components/Icon';

const LeaveSandbox = React.forwardRef((_props, ref) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { drawerExpanded } = useContext(sideDrawerStatus);

  const leaveSandbox = () => {
    disableTestEnv();

    navigate(location.pathname, { replace: true });
    window.location.reload();
  };
  useEffect(() => {}, [drawerExpanded]);

  return (
    <>
      {drawerExpanded && (
        <Button
          ref={ref as React.RefObject<HTMLButtonElement>}
          onClick={leaveSandbox}
          className="leave"
          disableRipple
        >
          <Icon name="Leave" height={13.33} width={13.33} />
          Leave Database
        </Button>
      )}
    </>
  );
});

export default memo(LeaveSandbox);
